/* eslint-disable */
import { BiShoppingBag, BiPencil } from "react-icons/bi";
import { BsCodeSlash, BsClipboardData } from "react-icons/bs";
import { AiOutlineMail, AiFillAudio } from "react-icons/ai";
import { FaInternetExplorer, FaChalkboardTeacher, FaCameraRetro, FaPinterest, FaVideo, FaTabletAlt, FaRegNewspaper, FaWordpress, FaServer, FaLaptopCode, FaSearch, FaPalette, FaMobile, FaDatabase, FaCloud, FaPhp, FaLaravel, FaPuzzlePiece, FaShoppingCart, FaPlug } from "react-icons/fa";
import { MdWeb, MdExtension, MdSpeed, MdSecurity } from "react-icons/md";
import { HiCode } from "react-icons/hi";
import { SiSymfony } from "react-icons/si";

 

export const servicesData = [
    {
        id: 1,
        title: 'Full Stack Development',
        icon: <FaLaptopCode />
    },
    {
        id: 2,
        title: 'Responsive Design',
        icon: <FaMobile />
    },
    {
        id: 3,
        title: 'API Development',
        icon: <FaPlug />
    },
    {
        id: 4,
        title: 'Custom PHP Development',
        icon: <FaPhp />
    },
    {
        id: 5,
        title: 'Laravel Development',
        icon: <FaLaravel />
    },
    {
        id: 6,
        title: 'Symfony Development',
        icon: <SiSymfony />
    },
    {
        id: 7,
        title: 'Database Design',
        icon: <FaDatabase />
    },
    {
        id: 8,
        title: 'WordPress Development',
        icon: <FaWordpress />
    },
    {
        id: 9,
        title: 'E-commerce Development',
        icon: <FaShoppingCart />
    },
    {
        id: 10,
        title: 'Wordpress Plugins',
        icon: <MdExtension />
    },
    {
        id: 11,
        title: 'WordPress Themes',
        icon: <FaPalette />
    },
    {
        id: 12,
        title: 'Elementor Development',
        icon: <FaPuzzlePiece />
    },
    {
        id: 13,
        title: 'Web Security',
        icon: <MdSecurity />
    },
    {
        id: 14,
        title: 'SEO Optimization',
        icon: <FaSearch />
    },

]

// Uncomment your required service.
// Couldn't find the required services? Raise an issue on github at https://github.com/hhhrrrttt222111/developer-portfolio/issues/new
// You can also add on your own 😉.